export class ApplicationClass {
  firstName
  lastName
  email
  phone
  entityName
  entityState
  remainingERCCredits
  selectedReferredAffiliateId
  withPEO
  filedAfterDate
  quarters
  slug
  affiliateName
  agentId
  finishedApplication

  constructor(application = {}) {
    this.firstName = application.firstName ? String(application.firstName) : ''
    this.lastName = application.lastName ? String(application.lastName) : ''
    this.email = application.email ? String(application.email) : ''
    this.phone = application.phone ? String(application.phone) : ''
    this.entityName = application.entityName ? String(application.entityName) : ''
    this.entityState = application.entityState ? String(application.entityState) : ''
    this.remainingERCCredits = application.remainingERCCredits ? String(application.remainingERCCredits) : ''
    this.selectedReferredAffiliateId = application.selectedReferredAffiliateId ? String(application.selectedReferredAffiliateId) : ''
    this.withPEO = application.withPEO ? String(application.withPEO) : ''
    this.filedAfterDate = application.filedAfterDate ? String(application.filedAfterDate) : ''
    this.quarters = application.quarters ? [...application.quarters] : []
    this.slug = application.slug ? String(application.slug) : ''
    this.affiliateName = application.affiliateName ? String(application.affiliateName) : ''
    this.agentId = application.agentId ? String(application.agentId) : ''
    this.finishedApplication = application.finishedApplication ? Boolean(application.finishedApplication) : false
  }
}